import { DatosApoderado } from './tipos';

export const nombres = {
    deudores: {
        todos: 'Todos',
        deudores: 'Solo deudores',
        nodeudores: 'No deudores',
    },
    plan: {
        todos: 'Con cualquier plan',
        anual: 'Solo anual',
        intensivo: 'Solo intensivo',
    },
    sede: {
        'todos': 'Cualquier sede',
        'alameda': 'Solo Alameda',
        'san-fernando': 'Solo San Fernando',
        'uchile': 'Solo U. de Chile',
    },
} as const;

export type Nombres = typeof nombres;
type FiltrosPara<P extends keyof Nombres> = keyof Nombres[P];
export type Filtros = { [P in keyof Nombres]: FiltrosPara<P> };

export const funciones: {
    [P in keyof Nombres]: (fila: DatosApoderado, filtro: FiltrosPara<P>) => boolean;
} = {
    deudores: (fila, filtro) => {
        switch (filtro) {
            case 'todos':
                return true;
            case 'deudores':
                return fila.deudor === true;
            case 'nodeudores':
                return fila.deudor === false;
            default:
                return true;
        }
    },

    plan: (fila, filtro) => {
        switch (filtro) {
            case 'anual':
                return fila.planDeMatriculas === 'anual';
            case 'intensivo':
                return (
                    fila.planDeMatriculas === 'intensivo' ||
                    fila.planDeMatriculas === 'intensivo-vespertino'
                );
            case 'todos':
            default:
                return true;
        }
    },

    sede: (fila, filtro) => {
        switch (filtro) {
            case 'alameda':
                return fila.sede === 'alameda';
            case 'san-fernando':
                return fila.sede === 'san-fernando';
            case 'uchile':
                return fila.sede === 'uchile';
            case 'todos':
            default:
                return true;
        }
    },
};



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/BuscarApoderado/filtros.ts